import { z } from "zod"
import { AssignTierDtoSchema } from "@mimber/schema"

export const assignTierToMemberFormSchema = AssignTierDtoSchema.extend({
  tierId: z
    .string({ message: "Please select a membership tier" })
    .uuid("Please select a valid membership tier"),
  // DatePickerField clears to `null` (not `undefined`) when the date is
  // removed; normalize that to `undefined` so it's omitted from the
  // submitted payload rather than failing AssignTierDtoSchema's validation.
  dueAt: z
    .preprocess(
      (value) => (value === null ? undefined : value),
      AssignTierDtoSchema.shape.dueAt
    )
    .optional(),
})

export type AssignTierToMemberFormData = z.infer<
  typeof assignTierToMemberFormSchema
>
